// extracted by mini-css-extract-plugin
export default {"wrapper":"ZoomPhotoPopup_wrapper__judB5","logo":"ZoomPhotoPopup_logo__XkTeD","popup":"ZoomPhotoPopup_popup__2qjke","preview":"ZoomPhotoPopup_preview__GYWys"};